import _ from 'lodash';
import React from 'react';
import {Line, Pie, HorizontalBar} from 'react-chartjs-2';
import Number from 'components/Formaters/Number'

const TextChart = ({stats}) => 
{
  console.log(stats, stats.domains)
  return <span>
          <div>
            {_.map(stats.domains , (d,k) => 
              <span key={k}>
                <span>{d.label} : </span>
                <Number value={d.value}/>  {stats.unit} 
              </span>
            )}
          </div>
  </span>;  
return  <div>
    { stats.domains.map((d, i) => {
      return <div key={i}>
        <span>{d.label}</span>
        <span className="SegmentList">
          {d.data.map( (v,ii) => <span key={i +''+ ii}>{v.value} {d.unit}</span>)}
        </span>
      </div>
    }
    ) }
  </div>
}


export default ({stats}) => {
  const options = {  
    scales: {
      xAxes: [{
        barThickness: 10,
        categoryPercentage:5,
        barPercentage: 0.5,
        ticks: {
          suggestedMin: _.min( _.map(stats.domains , (d,k) => 1*d.value ) ) - 1,
          suggestedMax: _.max( _.map(stats.domains , (d,k) => 1*d.value ) ) + 1
        }
      }],
      yAxes: [{
        barThickness: 10,
        categoryPercentage:0.5,
        barPercentage: 0.5
      }]
    }
  };

  const pie_options = {  
    
  };
  const data = {
    labels: [],
    datasets: 
    [
      {
        fillColor: ["#0288d1",  "#90C2E7","#092327","#0B5351", "#4E8098"],
        borderColor: (stats.chart === 'line') ? "#0288d1" : ["#0288d1",  "#90C2E7","#092327","#0B5351", "#4E8098"],
        fill: true,//(stats.chart !== 'line'),
        backgroundColor: (stats.chart === 'line') ? "rgba(6, 136, 209, 0.5)" : ["#0288d1",  "#90C2E7","#092327","#0B5351", "#4E8098"],
        data: [],
      }
    ]
  };
  data.labels = _.map(stats.domains , (d,k) => d.label );
  data.datasets[0].data = _.map(stats.domains , (d,k) => 1*d.value );
  data.datasets[0].label = stats.name;

  var height = (data.labels.length + 1.5 ) * 10;
  return (
    <div>
      {stats.chart === 'line' && <Line width={400} options={pie_options}  data={data} /> }
      {stats.chart === 'pie' &&  <Pie width={400} options={pie_options}  data={data} /> }
      {stats.chart === 'circle' &&  <Pie width={400} options={pie_options}  data={data} /> }
      {stats.chart === 'bar' &&  <HorizontalBar options={options}  data={data} /> }
      {stats.chart === 'text' &&  <TextChart stats={stats} /> }
    </div>
  );  
}




// WEBPACK FOOTER //
// ./src/components/Charts/Chart.jsx